import _ from "lodash";
import React from "react";
import classNames from "classnames";
import classes from "./Card.scss";
import { getTimeSince, getStyleStrippedText } from "Utils";
import I18nHOC from "UIComponents/I18nHOC";
import MoreItemWithToolTip from "UIComponents/MoreItemWithToolTip";
import { localeParamsHelper } from "Utils";
import { RESOURCE_PLACEHOLDER_URL } from "store/static";
import { isParentUserType } from "AttendanceSummary/modules/Utils";
import {
  getSpecifiedIcon,
  getRethumb,
} from "AppComponents/NotificationCenterV2/modules/Utils";

const ImagePlaceHolder = ({
  imageUrl,
  imageThumbSize,
  icon,
  bgColor,
  containerStyle,
  // userName
}) => {
  const rethumpUrl = imageUrl
    ? getRethumb({
        imageUrl: imageUrl,
        imageThumbSize,
      })
    : null;

  return (
    <div
      className={classes.imageContainer}
      style={{
        ...containerStyle,
        backgroundImage: rethumpUrl,
        backgroundColor: bgColor,
      }}
    >
      {/* {!imageUrl && _.first(userName) && (
        <span className={classes.initials}>{_.first(userName)}</span>
      )} */}
      {!!icon &&
        (rethumpUrl ? <div className={classes.overlay}>{icon}</div> : icon)}
      {/* <span className={classes.iconWrapper}>{icon} </span> */}
    </div>
  );
};

//@info: this Card component is not used in the production because it is old ui notification list card component
class Card extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  renderNotifications = ({ message, tokens, localizationKey, type }) => {
    const { t } = this.props;
    if (!localizationKey) {
      return message;
    }

    switch (type) {
      case "CIRCULAR_ADDED": {
        if (!_.isEmpty(tokens)) {
          const localeParam = localeParamsHelper({ params: tokens, t });
          return t(`notifications:${localizationKey}`, localeParam);
        }
        return message;
      }

      default: {
        const localeParam = localeParamsHelper({ params: tokens, t });
        return t(`notifications:${localizationKey}`, localeParam);
      }
    }
  };

  renderNotificationTitle = ({ title, localizationKey, tokens, type }) => {
    const { t } = this.props;

    if (localizationKey && type != "CIRCULAR_ADDED") {
      const localeParam = localeParamsHelper({ params: tokens, t });
      return t(localizationKey, localeParam);
    }

    return title;
  };

  render() {
    const {
      props: { item, onNotificationClicked, notificationDetails, t, user_type },
    } = this;
    const regex = /"([^"]+)"/g;

    const {
      type,
      isRead,
      message,
      createdAt,
      course,
      metadata,
      createdBy,
      courses,
      category,
      messageData,
    } = item;

    const { localeKey: localizationKey, tokens } = messageData || {};

    const coursesTitles = _.map(courses, item => {
      return `${_.get(item, "title", "")}`;
    });

    const containerClass = classNames(
      { [classes.mainContainer]: true },
      { [isRead ? classes.isRead : classes.notRead]: true }
    );

    const { label, useDefaultImage, studentLabel, familyLabel } =
      notificationDetails || {};

    const sliceIcons = [];
    const iconsLength = _.get(sliceIcons, "length", 0);
    const { title, titleLocalizationKey } = metadata || {};
    const contentSubType = _.get(metadata, "contentSubType");
    const { firstName, lastName } = createdBy || {};

    const { svgIcon, bgColor } = _.get(notificationDetails, "subCategories")
      ? getSpecifiedIcon({ metadata, notificationDetails, type })
      : notificationDetails;

    const iconContainerClass = classNames(
      { [classes.iconContainer]: true },
      { [classes.communityIconContainer]: category == "COMMUNITY" }
    );

    const contentContainerClass = classNames(
      { [classes.contentContainer]: true },
      { [classes.communityContentContainer]: category == "COMMUNITY" }
    );

    const labelLocalizationKey = titleLocalizationKey
      ? `notifications:${titleLocalizationKey}`
      : undefined;

    let newLabel = labelLocalizationKey || label;

    if (user_type == "student") {
      newLabel = labelLocalizationKey || studentLabel || label;
    }

    if (isParentUserType(user_type)) {
      newLabel = labelLocalizationKey || familyLabel || label;
    }

    if (user_type === "parent" && type === "CHAT_MESSAGE_SENT") {
      newLabel = "notifications:teacher_message_sent";
    }
    if (contentSubType == "dp_pa" && type === "ASSIGNMENT_CREATE") {
      newLabel = "notifications:new_practical_activity";
    }
    if (contentSubType == "dp_ep" && type === "ASSIGNMENT_CREATE") {
      newLabel = "notifications:new_experimental_programme";
    }

    const defaultImage = useDefaultImage ? RESOURCE_PLACEHOLDER_URL : "";

    return (
      <div
        className={containerClass}
        onClick={e => onNotificationClicked(item)}
      >
        <div className={contentContainerClass}>
          <div
            className={iconContainerClass}
            style={
              iconsLength > 1
                ? {
                    transform: `translate(${-(iconsLength - 1) * 8}px, 0px)`,
                  }
                : {}
            }
          >
            {!isRead && <div className={classes.readDot}></div>}
            {iconsLength > 0 ? (
              _.map(sliceIcons, (icon, index) => {
                return (
                  <ImagePlaceHolder
                    key={index}
                    containerStyle={
                      iconsLength > 1
                        ? {
                            border: "1px solid white",
                            transform: `translate(${index * 8}px, 0px) scale(${
                              1 - iconsLength * 0.1 + index * 0.1
                            })`,
                          }
                        : {}
                    }
                    imageUrl={_.get(icon, "url", defaultImage)}
                    // userName={_.get(icon, "userName")}
                    icon={svgIcon}
                    imageThumbSize={128}
                    bgColor={bgColor}
                  />
                );
              })
            ) : (
              <ImagePlaceHolder
                imageThumbSize={128}
                icon={svgIcon}
                bgColor={bgColor}
                imageUrl={defaultImage}
              />
            )}
          </div>

          <div className={classes.contentTextContainer}>
            {category != "COMMUNITY" && (
              <div className={classes.contentHeaderContainer}>
                <div className={classes.contentHeader}>
                  {this.renderNotificationTitle({
                    title,
                    localizationKey: newLabel,
                    tokens,
                    type,
                  })}
                </div>
                <div className={classes.duration}>
                  {getTimeSince(createdAt, t)}
                </div>
              </div>
            )}

            <div
              dangerouslySetInnerHTML={{
                __html: getStyleStrippedText({
                  text: this.renderNotifications({
                    message,
                    tokens,
                    localizationKey,
                    type,
                    metadata,
                  }),
                  type: "SANITIZE_DANGER_HTML_PARAGRAPH",
                }),
              }}
              className={classes.content}
            />
            {category != "COMMUNITY" ? (
              <div className={classes.detailContainer}>
                {type == "CIRCULAR_ADDED" && (
                  <span>{`${firstName} ${lastName}`}</span>
                )}
                {type == "CIRCULAR_ADDED" &&
                  _.get(coursesTitles, "length", 0) > 0 && (
                    <span className={classes.dotContainer}>{`•`}</span>
                  )}
                {_.get(coursesTitles, "length", 0) > 0 && (
                  <MoreItemWithToolTip
                    items={coursesTitles}
                    tooltipPlacement={"bottom"}
                    length={1}
                    allItemsText={t("common:all_label", {
                      label: t("common:course_plural"),
                    })}
                  />
                )}
              </div>
            ) : (
              <div
                className={classes.duration}
                style={category == "COMMUNITY" ? { marginTop: 0 } : {}}
              >
                {getTimeSince(createdAt, t)}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default I18nHOC({
  resource: [
    "common",
    "project",
    "notifications",
    "journal",
    "assessmentEvaluation",
    "classRoom",
  ],
})(Card);
